export const DateFormat = {
	shortDate: 'MM/DD/YYYY',
	shortDateTime: 'MM/DD/YYYY h:mm:ss a',
	orbitDate: 'YYYYMMDD', // CCYYMMDD
	formatMMMDYYYY: 'MMM D, YYYY', // Sep 3, 2023
	fileDate: 'YYYY-MM-DD',
};
